import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import { get, isArray } from 'lodash-es';

class GdsButtonModelServiceModule {
}
GdsButtonModelServiceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonModelServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsButtonModelServiceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonModelServiceModule });
GdsButtonModelServiceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonModelServiceModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonModelServiceModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class GdsButtonModelService {
    constructor(injector) {
        this.injector = injector;
        this.buttonArray = [];
    }
    get utilities() {
        if (!this._utilities) {
            this._utilities = this.injector.get(GdsCommonUtilityService);
        }
        return this._utilities;
    }
    init(field, isMedia, isArray, isXpath) {
        if (isMedia) {
            return this.parseLegacyMediaButton(field, isXpath);
        }
        const embeddedValues = get(field, 'EmbeddedValues', []);
        this.buttonArray = [];
        for (let i = 0; i <= embeddedValues.length - 1; i++) {
            const btnType = get(field, `EmbeddedValues[${i}].type.Values[0]`);
            const target = get(field, `EmbeddedValues[${i}].target.KeywordValues[0].Key`);
            const label = isXpath
                ? get(field, `EmbeddedValues[${i}].label.XPath`)
                : get(field, `EmbeddedValues[${i}].label.Values[0]`);
            const analytics = get(field, `EmbeddedValues[${i}].analytics.Values[0]`);
            const title = get(field, `EmbeddedValues[${i}].title.Values[0]`);
            const ariaLabel = get(field, `EmbeddedValues[${i}].ariaLabel.Values[0]`);
            const svg = get(field, `EmbeddedValues[${i}].svgOptions.KeywordValues[0].Key`);
            const customEventDetail = get(field, `EmbeddedValues[${i}].link.EmbeddedValues[0].Component.LinkedComponentValues[0].Fields.customEventDetail.EmbeddedValues`) ||
                get(field, `EmbeddedValues[${i}].customEventDetail.EmbeddedValues`);
            const action = get(field, `EmbeddedValues[${i}].action.Values[0]`);
            if (btnType === 'none') {
                return null;
            }
            if (target === 'youtube') {
                const youtubeUrl = this.utilities.getHref(embeddedValues[i]);
                this.buttonArray.push({
                    label,
                    analytics,
                    type: btnType,
                    target,
                    svgOptions: {
                        iconName: svg,
                    },
                    title: title || label,
                    ariaLabel: ariaLabel || label,
                    videoCaption: ariaLabel,
                    videoId: youtubeUrl,
                    href: youtubeUrl,
                    customEventDetail: customEventDetail,
                    action,
                });
            }
            else if (btnType)
                this.buttonArray.push({
                    label,
                    href: this.utilities.getHref(embeddedValues[i]),
                    anchor: this.utilities.getAnchor(embeddedValues[i]),
                    analytics,
                    type: btnType,
                    target,
                    svgOptions: {
                        iconName: svg,
                    },
                    title,
                    ariaLabel,
                    modalContent: get(field, `EmbeddedValues[${i}].link.EmbeddedValues[0].Component.LinkedComponentValues[0].Fields.elements`),
                    customEventDetail,
                    action,
                });
            else {
                this.buttonArray.push({
                    label,
                    ariaLabel,
                    analytics,
                    svgOptions: {
                        iconName: svg,
                    },
                });
            }
        }
        return isArray ? this.buttonArray : this.buttonArray[0];
    }
    initRelatedTileLink(tileLink) {
        return {
            href: this.utilities.getHref(get(tileLink, 'PageUrl'), false),
            analytics: get(tileLink, 'PageUrlAnalyticsID'),
            ariaLabel: get(tileLink, 'PageUrlAriaLabel'),
        };
    }
    getSvgIconName(buttons, i) {
        let iconName = get(buttons, `[${i}].svgOptions`, '');
        if (typeof iconName === 'object') {
            iconName = get(iconName, 'iconName', '');
        }
        return iconName;
    }
    mapButtonData(buttons) {
        if (!!buttons && !isArray(buttons)) {
            buttons = [buttons];
        }
        if (!!buttons && buttons.length > 0) {
            const buttonArray = [];
            for (let i = 0; i <= buttons.length - 1; i++) {
                const target = get(buttons, `[${i}].target`, '');
                const keys = Object.keys(buttons[i]);
                if (keys.length === 2 &&
                    keys.includes('target') &&
                    keys.includes('type')) {
                    buttonArray.push({});
                }
                else {
                    buttonArray.push({
                        label: get(buttons, `[${i}].label`, ''),
                        analytics: get(buttons, `[${i}].analytics`, ''),
                        type: get(buttons, `[${i}].type`, ''),
                        target,
                        description: get(buttons, `[${i}].description`, ''),
                        href: this.utilities.resolveLinkUrl(get(buttons, `[${i}].link[0].External`, ''), target) ||
                            this.utilities.resolveLinkUrl(get(buttons, `[${i}].href[0].External`) ||
                                get(buttons, `[${i}].href`), target) ||
                            this.utilities.resolveLinkUrl(get(buttons, `[${i}].link[0].Component[0].ResolvedUrl`, ''), target),
                        image: this.utilities.resolveImagePath(get(buttons, `[${i}].image`, '')),
                        svgOptions: {
                            iconName: this.getSvgIconName(buttons, i),
                        },
                        title: get(buttons, `[${i}].title`, '') ||
                            get(buttons, `[${i}].label`, ''),
                        ariaLabel: get(buttons, `[${i}].ariaLabel`, '') ||
                            get(buttons, `[${i}].label`, ''),
                        videoId: get(buttons, `[${i}].videoId`, ''),
                        videoCaption: get(buttons, `[${i}].vidoeCaption`, ''),
                        modalContent: get(buttons, `[${i}].link[0].Component[0].elements`, '') ||
                            get(buttons, `[${i}].modalContent`, ''),
                        customEventDetail: get(buttons, `[${i}].link[0].Component[0].customEventDetail`, ''),
                    });
                }
            }
            return buttonArray.length === 1 ? buttonArray[0] : buttonArray;
        }
    }
    mapProfileButtonData(buttons) {
        if (!!buttons && buttons.length > 0) {
            const buttonArray = [];
            for (let i = 0; i <= buttons.length - 1; i++) {
                buttonArray.push({
                    label: get(buttons, `[${i}].button[0].label`, ''),
                    analytics: get(buttons, `[${i}].button[0].analytics`, ''),
                    flag: get(buttons, `[${i}].flag`, ''),
                    type: 'hamburger-nav-secondary',
                    target: get(buttons, `[${i}].button[0].target`, ''),
                    description: get(buttons, `[${i}].button[0].description`, ''),
                    href: this.utilities.resolveLinkUrl(get(buttons, `[${i}].button[0].link[0].External`, '')) ||
                        this.utilities.resolveLinkUrl(get(buttons, `[${i}].button[0].href[0].External`, '')) ||
                        this.utilities.resolveLinkUrl(get(buttons, `[${i}].button[0].link[0].Component[0].ResolvedUrl`, '')) ||
                        this.utilities.resolveLinkUrl(get(buttons, `[${i}].button[0].link[0].Component[0].ResolvedUrl`, '')),
                    image: this.utilities.resolveImagePath(get(buttons, `[${i}].button[0].image`, '')),
                    svgOptions: {
                        iconName: 'profile',
                    },
                    title: get(buttons, `[${i}].button[0].title`, '') ||
                        get(buttons, `[${i}].button[0].label`, ''),
                    ariaLabel: get(buttons, `[${i}].button[0].ariaLabel`, '') ||
                        get(buttons, `[${i}].button[0].label`, ''),
                    videoId: get(buttons, `[${i}].button[0].videoId`, ''),
                    videoCaption: get(buttons, `[${i}].button[0].vidoeCaption`, ''),
                    modalContent: get(buttons, `[${i}].button[0].link[0].Component[0].elements`, ''),
                    customEventDetail: get(buttons, `[${i}].button[0].link[0].Component[0].customEventDetail`, ''),
                });
            }
            return buttonArray.length === 1 ? buttonArray[0] : buttonArray;
        }
    }
    mapProfileToggleButtonData(toggleButtons) {
        if (!!toggleButtons && toggleButtons.length > 0) {
            const toggleButtonArray = [];
            for (let i = 0; i <= toggleButtons.length - 1; i++) {
                toggleButtonArray.push({
                    label: get(toggleButtons, `[${i}].toggleButton[0].label`, ''),
                    analytics: get(toggleButtons, `[${i}].toggleButton[0].analytics`, ''),
                    flag: get(toggleButtons, `[${i}].flag`, ''),
                    eventName: get(toggleButtons, `[${i}].eventName`, ''),
                    positiveLabel: get(toggleButtons, `[${i}].toggleButton[0].positiveLabel`, ''),
                    negativeLabel: get(toggleButtons, `[${i}].toggleButton[0].negativeLabel`, ''),
                    ariaLabel: get(toggleButtons, `[${i}].toggleButton[0].ariaLabel`, '') ||
                        get(toggleButtons, `[${i}].toggleButton[0].label`, ''),
                });
            }
            return toggleButtonArray.length === 1
                ? toggleButtonArray[0]
                : toggleButtonArray;
        }
    }
    parseLegacyMediaButton(field, isXpath) {
        const label = isXpath
            ? get(field, 'EmbeddedValues[0].label.XPath')
            : get(field, 'EmbeddedValues[0].label.KeyWordValues[0].Title') ||
                get(field, 'EmbeddedValues[0].label.Values[0]');
        const mediaBtnData = {
            label: label,
            analytics: get(field, 'EmbeddedValues[0].analytics.Values[0]'),
            type: get(field, 'EmbeddedValues[0].label.KeyWordValues[0].Key'),
            title: get(field, 'EmbeddedValues[0].title.Values[0]') || label,
            ariaLabel: get(field, 'EmbeddedValues[0].ariaLabel.Values[0]') || label,
            videoId: get(field, `EmbeddedValues[0].videoId.Values[0]`),
            videoCaption: get(field, `EmbeddedValues[0].vidoeCaption.Values[0]`),
        };
        const hasMediaBtnData = Object.values(mediaBtnData).some((val) => val !== undefined && val !== null);
        if (hasMediaBtnData && !mediaBtnData.type)
            mediaBtnData.type = 'play';
        return mediaBtnData;
    }
}
GdsButtonModelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonModelService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
GdsButtonModelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonModelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonModelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

export { GdsButtonModelService, GdsButtonModelServiceModule };
